import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityLock } from "../../entity/EntityLock";

export class DtoLocksGetReq extends EntityLock {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------
    if (!commonRegx.isMatch(this.c_lock_id!.toString(), "^\\d+$", commonRegx._stdOption)) {
      res.push("type error");
    }

    return res;
  }
}
